import { Spinner } from '@nextui-org/react';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { StoreState } from '../../../store/reducer-main';
import { firestoreDocRead, firestoreDocUpdate, firestoreOnSnapshot, firestoreWrite } from '../../../service/common/firebase';
import { PROCESSING_PAYMENTS_DB_REF } from '../../../constants/firestore';
import { checkProcessingPayment, ProcessingPayment } from '../../../service/processingPayments';
import { updateProcessingPaymentState } from '../../../store/processingPayment/slice';
import { ProcessingPaymentState } from '../../../enums/processingPayments';

export default function ProcessingPaymentPage() {

  const dispatch = useDispatch();
  const { userProfile } = useSelector((state: StoreState) => state.profile);

  React.useEffect(() => {
    if (!userProfile) return;
    const unsubscribe = firestoreOnSnapshot(PROCESSING_PAYMENTS_DB_REF, userProfile.uid, (docSnap) => {
      if (docSnap.exists()) {
        const status = (docSnap.data() as ProcessingPayment).state;
        dispatch(updateProcessingPaymentState(status));
      }
    });
    checkProcessingPayment(userProfile.uid);
    /* const t_id = setTimeout(async() => {
      const ppSnap = await firestoreDocRead(PROCESSING_PAYMENTS_DB_REF, userProfile.uid);
      if (ppSnap.exists() && ppSnap.data().state === ProcessingPaymentState.PENDING) {
        await firestoreDocUpdate(PROCESSING_PAYMENTS_DB_REF, userProfile.uid, {state: ProcessingPaymentState.FAILED});
      }
    }, 5 * 1000); */
    return () => {
      unsubscribe();
      //clearTimeout(t_id);
    }
  }, []);

  return  (
    <div style={{display: 'flex', width: '100vw', height: '100vh', justifyContent: 'center', alignItems: 'center', gap: 16}}>
      <p className='text-xl font-medium mx-7'>Processing payment...</p>
      <Spinner />
    </div>
  )
}